import { useEffect } from 'react';

/**
 * Sets the document title and meta description for a page.
 */
export default function usePageMeta(title: string, description: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const tag = document.querySelector('meta[name="description"]');
    const previousDescription = tag?.getAttribute('content') ?? null;
    if (tag) tag.setAttribute('content', description);

    return () => {
      document.title = previousTitle;
      if (tag && previousDescription !== null) tag.setAttribute('content', previousDescription);
    };
  }, [title, description]);
}